export const table_titles = [
	{ name: "#", size: 10, order: "" },
	{ name: "Nombre", size: 10, order: "name" },
	{ name: "Campos", size: 10, order: "" },
	{ name: "Bodegas", size: 10, order: "" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 10,
	order: "name",
	orderType: "desc",
	type: "settings",
};

export const base_element = {
	id: "",
	name: "",
	customer_id: "",
	estates_parents: [],
	estates: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
